




























































import {Component, Vue, Watch} from 'vue-property-decorator';
import dayjs from 'dayjs';
import formatTsNum from '@/lib/formatTsNum';
import mathjs from 'mathjs';
import * as math from 'mathjs';

@Component
export default class Calendar extends Vue {
  public value = new Date();
  public tallyRecord = [] as RecordItem[];
  public type = 'pay';

  get seletedData() {
    const YMD = dayjs(this.value).format('YYYY-MM-DD');
    const currentDay = YMD.split('-');
    currentDay[0] = currentDay[0] + '年';
    currentDay[1] = currentDay[1] + '月';
    currentDay[2] = currentDay[2] + '日';

    const currentData = this.tallyRecord.filter((item: RecordItem) => {
      return item.date === YMD;
    });
    if (!currentData) {
      return currentData;
    }
    let earn = 0;
    let pay = 0;
    for (const item of currentData) {
      if (item.type === 'earn') {
        earn = earn + Number(formatTsNum(this.exactingFloat(Number(item.amount))));

      } else if (item.type === 'pay') {
        pay = pay + Number(formatTsNum(this.exactingFloat(Number(item.amount))));
      }
    }

    const groupData = {
      date: currentDay.join(''),
      today: currentData,
      earn,
      pay,
      count: this.exactingFloat(earn - pay),
    };
    // console.log(groupData.earn,groupData.pay,'group')

    return groupData;
  }


  public beforeMount() {
    this.$store.commit('fetchTags');
    this.$store.commit('fetchRecord');
    this.tallyRecord = this.$store.state.tallyRecord;
  }

  public exactingFloat(value: number) {
    // console.log(value,'count2')
    const precision = 16;
    let result = math.format(value, precision);
    if (result.indexOf('e')) {

      const formatNumber = Number(result);
      result = formatNumber.toLocaleString();

      return result;
    } else {
      return result;
    }


  }

  public toBack() {
    this.$router.back();
  }

  public hasRecord(date: string) {
    const result = '💡';
    for (const item of this.tallyRecord) {
      if (item.date === date) {
        return result;
      }
    }
  }
}
